import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { ScrollAnimation } from '../../components/common/ScrollAnimation';
import { Award, Heart, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';

export const AboutPage: React.FC = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <section
        className="relative text-white py-20 overflow-hidden"
        style={{ background: 'linear-gradient(135deg, #4c1d95 0%, #701a75 40%, #9d174d 100%)' }}
      >
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 right-0 w-72 h-72 rounded-full blur-3xl opacity-25" style={{ background: '#fda4af' }} />
          <div className="absolute bottom-0 left-0 w-72 h-72 rounded-full blur-3xl opacity-20" style={{ background: '#f0abfc' }} />
        </div>
        <div className="h-1 absolute top-0 left-0 right-0 bg-gradient-to-r from-violet-400 via-primary-400 via-rose-400 to-amber-400" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <motion.div
            initial={false}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <h1 className="text-4xl md:text-6xl font-bold mb-4">
              About{' '}
              <span className="bg-clip-text text-transparent" style={{ backgroundImage: 'linear-gradient(90deg, #fda4af, #fcd34d)' }}>
                Us
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-purple-200 max-w-3xl mx-auto">
              Welcome to AANAND VIDEO COVERAGE
            </p>
          </motion.div>
        </div>
      </section>

      {/* About Content */}
      <section className="py-20 relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #fdf4ff 0%, #fae8ff 100%)' }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <ScrollAnimation direction="fade">
            <div className="bg-gradient-to-br from-white to-primary-50 border border-primary-100 rounded-3xl p-10 shadow-xl">
              <h2 className="text-3xl font-bold mb-6 gradient-text">HELLO, WE ARE GLAD YOU FOUND US!</h2>
              <p className="text-gray-700 mb-6 text-lg leading-relaxed">
                We are one of the top wedding photography studios around the country that has started to expand
                its horizons throughout the globe. Our team of wedding photographers is here to assist you in
                having a meaningful, stress-free, and real event while uniquely documenting your love.
              </p>
              <p className="text-gray-700 mb-6 text-lg leading-relaxed">
                We want to be available for you all day long and that includes from the get go. During the
                wedding photoshoot, we give our best to help the couple with different wedding poses. We have
                written hundreds of original love stories using our expertise in photography all around the world.
              </p>
              <p className="text-gray-700 text-lg leading-relaxed">
                Your photos should bring back fond memories for you along with all the emotions that make you
                shiver and bring goosebumps down your arms. We also do Creative pre-wedding photography for our
                bride and groom. We are passionate about each and every frame, and our team works very hard to
                make sure that you will cherish your special day for a lifetime with their expert wedding photography.
              </p>
            </div>
          </ScrollAnimation>
        </div>
      </section>

      {/* Colorful divider */}
      <div className="h-1.5 w-full bg-gradient-to-r from-violet-500 via-rose-500 via-amber-500 to-emerald-500" />

      {/* What We Do */}
      <section className="py-20 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #ecfeff 0%, #fdf4ff 100%)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <ScrollAnimation direction="fade">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 gradient-text">What Do We Do?</h2>
            <h3 className="text-2xl font-semibold text-center mb-12 text-gray-600">We take our craft seriously.</h3>
          </ScrollAnimation>
          <div className="max-w-4xl mx-auto">
            <ScrollAnimation direction="up">
              <div className="bg-gradient-to-br from-violet-50 to-purple-50 border border-violet-200 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all">
                <p className="text-gray-700 text-lg leading-relaxed mb-6">
                  We believe that a wedding should be all about the couple and not only about customs, or what
                  the family wants, or a series of posed pictures with odd lighting. From straightforward coverage
                  to themed documentary-style wedding albums, the field of wedding photography and videography
                  in India has changed.
                </p>
                <p className="text-gray-700 text-lg leading-relaxed">
                  In order to preserve our distinctive fun and offbeat candid style videography, our wedding
                  photographers and cinematographers concentrate on creating simple wedding stories that are
                  inventive yet extraordinary. With the goal of capturing emotions, genuine moments, small,
                  unnoticed moments how you are in your daily life, authentic and undisguised, we want to
                  chronicle your wedding in the manner of contemporary wedding photography.
                </p>
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #fdf4ff 0%, #fff1f2 50%, #fffbeb 100%)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <ScrollAnimation direction="fade">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 gradient-text">Our Values</h2>
          </ScrollAnimation>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { icon: Heart, title: 'Passion', desc: 'We are passionate about every frame we capture', gradient: 'from-rose-500 to-pink-600', shadow: 'shadow-rose-400/30', bg: 'from-rose-50 to-pink-50', border: 'border-rose-200' },
              { icon: Award, title: 'Excellence', desc: 'Committed to delivering the highest quality', gradient: 'from-amber-500 to-orange-600', shadow: 'shadow-amber-400/30', bg: 'from-amber-50 to-orange-50', border: 'border-amber-200' },
              { icon: Sparkles, title: 'Creativity', desc: 'Unique and artistic approach to photography', gradient: 'from-violet-500 to-purple-600', shadow: 'shadow-violet-400/30', bg: 'from-violet-50 to-purple-50', border: 'border-violet-200' },
            ].map((value, index) => (
              <ScrollAnimation key={index} direction="up" delay={index * 0.1}>
                <motion.div
                  whileHover={{ y: -10, scale: 1.03 }}
                  className={`text-center p-8 rounded-2xl bg-gradient-to-br ${value.bg} border ${value.border} shadow-lg ${value.shadow} hover:shadow-2xl transition-all`}
                >
                  <div className={`bg-gradient-to-br ${value.gradient} rounded-full p-5 w-20 h-20 mx-auto mb-4 flex items-center justify-center shadow-lg ${value.shadow}`}>
                    <value.icon className="h-10 w-10 text-white" />
                  </div>
                  <h3 className="text-xl font-bold mb-2 text-gray-800">{value.title}</h3>
                  <p className="text-gray-600">{value.desc}</p>
                </motion.div>
              </ScrollAnimation>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};
